export default {"src":"/_next/static/media/gujarat.969fbddd.svg","height":336,"width":199,"blurWidth":0,"blurHeight":0};